import { render, staticRenderFns } from "./node-status-buttons.vue?vue&type=template&id=0a81c439&scoped=true&"
import script from "./node-status-buttons.vue?vue&type=script&lang=ts&"
export * from "./node-status-buttons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a81c439",
  null
  
)

export default component.exports